import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { setupStore } from './stores';
import { logger } from './utils';
import './eventBus/register';
import { apiUnhandledErrorNoticeService } from './services/api/ApiUnhandledErrorNoticeService';

import 'virtual:uno.css';
// 导入全局样式
import './assets/styles/main.css';

// 创建 Vue 应用实例
const app = createApp(App);

// 配置 Pinia 状态管理
setupStore(app);

// 安装 Vue Router
app.use(router);

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  logger.error('Vue 全局错误', { err, info });
  console.error('Vue Error:', err);
};

// 挂载应用
app.mount('#app');

// 安装全局 API 未处理错误通知层：仅兜底没有被调用方 catch 的接口错误。
apiUnhandledErrorNoticeService.install();
